import script from "./TiktokAccountSettingsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TiktokAccountSettingsDialog.vue?vue&type=script&setup=true&lang=js"

import "./TiktokAccountSettingsDialog.vue?vue&type=style&index=0&id=fcff9588&lang=scss"
import "./TiktokAccountSettingsDialog.vue?vue&type=style&index=1&id=fcff9588&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcff9588"]])

export default __exports__